import React, { useContext, useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { i18nContext } from '@/components/pages/assessments/context/i18n.context';
import { displayContext } from '@/components/pages/assessments/context/display.context';
import SkipButton from '@/components/pages/assessments/common/SkipButton';

const QuestionSelect = ({ question, answer, setAnswer, setQuestionComplete, previewOnly = false }) => {
  const { t } = useContext(i18nContext);
  const { css } = useContext(displayContext);
  const [values, setValues] = useState(answer || []);
  const [isSkipped, setIsSkipped] = useState(answer === null);
  const required = !!question.required;

  const handleChange = (opt) => {
    if (!previewOnly) {
      setValues(opt);
    }
  };

  const handleSkipClick = () => {
    if (!previewOnly) {
      setIsSkipped(true);
      setValues(null);
    }
  };

  useEffect(() => {
    if (!previewOnly) {
      setQuestionComplete(isSkipped || (values !== null && values !== undefined && values?.length > 0));
      setAnswer(values);
    }
  }, [values, isSkipped, previewOnly]);

  return (
    <>
      <div className={`${css('question-input')} ${css('question-select')}`}>
        <Form.Select
          onChange={(e) => {
            handleChange(e.target.value);
          }}
          disabled={previewOnly}
        >
          <option value="">{question.helper_text}</option>
          {question.value_options.map((opt) => {
            return (
              <option key={opt} value={opt}>
                {t(opt)}
              </option>
            );
          })}
        </Form.Select>
        {!required && !previewOnly && <SkipButton isSkipped={isSkipped} onButtonClick={handleSkipClick} />}
      </div>
    </>
  );
};

export default QuestionSelect;
